import React from "react";
import Parallax from "react-rellax";
import "./Main.css";
import Flock from "./Flock";
import Header from "./Header";

class Main extends React.Component {
  render() {
    const {
      url,
      updateBirdScripts,
      birdScripts,
      updatePageHeader,
      pageHeader,
    } = this.props;
    return (
      <>
        <Flock
          parent="container"
          url={url}
          updateBirdScripts={updateBirdScripts}
          birdScripts={birdScripts}
        />
        <div className="parallax-container" id="container">
          <div className="background" />
          <Parallax speed={1}>
            <img
              className="mountain-layer"
              src={`${url}/images/mountain-layer.svg`}
              alt=""
            />
          </Parallax>
          <Parallax speed={1.5}>
            <img
              className="castle-section"
              src={`${url}/images/castle-prime.svg`}
              alt="view of castle in the distance"
            />
          </Parallax>
          <Parallax speed={2.5}>
            <img
              className="forest-section"
              src={`${url}/images/forest-prime.svg`}
              alt=""
            />
          </Parallax>
          <Parallax speed={3.5} id="bird-layer">
            <img
              className="forest-layer-front"
              src={`${url}/images/forest-layer-front.svg`}
              alt=""
            />
          </Parallax>
          <Parallax speed={4}>
            <img
              className="cliff-layer"
              src={`${url}/images/cliff-layer.svg`}
              alt="a cliff overlooking a valley"
            />
          </Parallax>
        </div>
        <Parallax speed={4}>
          <div className="red-section">
            <Header
              updatePageHeader={updatePageHeader}
              pageHeader={pageHeader}
            />
            <div className="container-80">
              <h1>
                <u>Introduction</u>
              </h1>
              <p>
                <span className="caps"></span>
                Step in to a high fantasy, 5th Edition D&D Campaign. This
                website holds a collection of lore, odd-rules, botes and maps
                for players to use at their leisure.
                <br />
                <br />
                The Campaign will take place in a Homebrew World. The
                inspiration for the setting comes from the Forgotten Realms,
                Witcher Series and 2nd edition Dungeons and Dragons. You can
                expect technology to be thoroughly medieval, monsters to be
                monstrous and races to be Tolkein-esque. The Campaign will run
                from level 1 up to as high as the story merits. As a player you
                can expect to grow from obscurity to being a major player on the
                world stage.
                <br />
                <br />
                The Campaign World I wish to share has been designed to develop
                and grow independent of the player input. Competant and
                motivated factions dominate the world and will pursue their own
                goals; or <b>you</b> should you get in their way. It will be up
                to you, and the characters you have designed, to choose what
                issues matter to them and where they want to interfere. Your
                characters will be the center of the story and powerful agents
                of change in a dangerous world.
              </p>
            </div>
          </div>
        </Parallax>
      </>
    );
  }
}

export default Main;
